import { Component, Input } from '@angular/core';


/**
   * Logger Factory
   * @namespace icon: name of icon to show
   * ES:
   * <ute-icon icon="add"></ute-icon>
*/

@Component({
  selector: 'ute-icon',
  templateUrl: 'ute-icon.component.html'
})
export class UteIconComponent  {
  @Input() icon: string;

  constructor() {
 
  }
   
  ngOnInit() {
   
  }
  
}


// WEBPACK FOOTER //
// ./src/app/components/atoms/ute-icon/ute-icon.component.ts